import React, { Component } from "react";
import { connect } from "react-redux";
import axios, { CancelToken } from "axios";
/* import $ from "jquery";
 */
import { Translate, I18n } from "react-redux-i18n";

import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import PhoneInput from "react-phone-input-2";

import { setAlert } from "../../../actions/alertActions";
import { selectCountry } from "../../utils/Utils";
import es from "react-phone-input-2/lang/es.json";
import "../../../styles/components/utils/components/AddUsersByPhone.scss";
import plus from "../../../styles/images/plus.svg";
import cross from "../../../styles/images/cross.svg";

class AddUsersByPhone extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.cancel = null;

    this.state = {
      validated: false,
      localization: {},
      users: [
        {
          prefix: "",
          phone: "",
          valid: false,
        },
      ],
    };

    this.handlePhoneChange = this.handlePhoneChange.bind(this);
    this.handleAddAnotherUser = this.handleAddAnotherUser.bind(this);
    this.handleRemoveInput = this.handleRemoveInput.bind(this);
    this.handleOnSubmit = this.handleOnSubmit.bind(this);
    this.resetState = this.resetState.bind(this);
  }

  loadLocale(locale) {
    /* 
    Current languages avaliable to react-phone-input-2,
    es Spanish, de Deutsch, ru Russian, fr French
    jp Japanese, cn Chinese, pt Portuguese, it Italian
    ir Iranian, ar Arabic, tr Turkish, id Indonesian
    hu Hungarian, pl Polish, ko Korean.
    source: https://www.npmjs.com/package/react-phone-input-2#predefined-localization
    */

    import(`react-phone-input-2/lang/${locale}.json`)
      .then((module) => {
        if (this._mounted) {
          this.setState({ localization: module.default });
        }
      })
      .catch((error) => {
        console.error("Failed to load language:", error);
        if (this._mounted) {
          this.setState({ localization: {} }); // fallback
        }
      });
  }

  componentDidMount() {
    this._mounted = true;
    let country = this.props.country;
    let countryCode = country.match(/^[^_]+/);
    this.loadLocale(countryCode);
  }

  componentWillUnmount(prevProps) {
    this._mounted = false;
    if (this.cancel) this.cancel("Component is unmounting");
    if (prevProps?.country !== this.props.country) {
      let country = this.props.country;
      let countryCode = country.match(/^[^_]+/);
      this.loadLocale(countryCode);
    }
  }

  handlePhoneChange(e, obj, idx) {
    const phone = e.replace(/[^0-9]+/g, "").slice(obj.dialCode.length);

    this.safeSetState((prevState) => ({
      users: [
        ...prevState.users.slice(0, idx),
        Object.assign({}, this.state.users[idx], {
          prefix: obj.dialCode,
          phone: e,
          valid: phone !== "" && phone !== obj.dialCode,
        }),
        ...prevState.users.slice(idx + 1),
      ],
    }));
  }

  handleAddAnotherUser(e) {
    const length = this.state.users.length;
    const lastUser = this.state.users[length - 1];

    if (
      lastUser.prefix !== "" &&
      lastUser.phone !== "" &&
      lastUser.phone !== lastUser.prefix
    )
      this.safeSetState((prevState) => ({
        users: [
          ...prevState.users,
          {
            prefix: "",
            phone: "",
            valid: false,
          },
        ],
      }));
  }

  handleRemoveInput(idx) {
    this.safeSetState((prevState) => ({
      users: [
        ...prevState.users.slice(0, idx),
        ...prevState.users.slice(idx + 1),
      ],
    }));
  }

  handleOnSubmit(e) {
    e.preventDefault();

    //This condition checks if a there none duplicate numbers being added at the same time.
    const unique = [
      ...new Set(this.state.users.map((user) => user.prefix && user.phone)),
    ];

    if (this.state.users.length > 1 && unique.length === 1) {
      this.props.setAlert(
        I18n.t("AddUsersByPhone_duplicated_numbers"),
        "danger"
      );
    } else {
      this.safeSetState({ validated: true }, () => {
        if (this.state.users.some((u) => !u.valid)) return; // do nothing if there's an input not valid

        const promises = this.state.users.map((user, idx) => {
          return axios
            .get("/api/private/users", {
              params: {
                mobile: user.phone
                  .replace(/[^0-9]+/g, "")
                  .slice(user.prefix.length),
                internationalPrefix: "+" + user.prefix,
              },
              cancelToken: new CancelToken((c) => (this.cancel = c)),
            })
            .then((res) => {
              if (res.status === 200) return Object.assign({}, res.data[0]);
            })
            .catch((err) => {
              if (
                err.response &&
                err.response.data &&
                err.response.data.code === "server_users_not_found"
              ) {
                return Object.assign({}, user);
              }

              if (axios.isCancel(err)) console.log("axios", err);
              else console.log(err);
            });
        });

        Promise.all(promises).then((responses) =>
          this.props.onSubmit(responses)
        );
      });
    }
  }

  resetState() {
    this.safeSetState({
      validated: false,
      users: [
        {
          prefix: "",
          phone: "",
          valid: false,
        },
      ],
    });
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    return (
      <Modal
        id="addUsersByPhone"
        show={this.props.show}
        onHide={this.props.onHide}
        onExited={this.resetState}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <Translate
              value={
                this.props.title && this.props.title !== ""
                  ? this.props.title
                  : "addUsersByPhone_addUsers"
              }
            />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form id="add-users-form" noValidate onSubmit={this.handleOnSubmit}>
            {this.state.users.map((u, i) => (
              <Form.Group key={i} className="form-field">
                <span>
                  <Form.Control
                    localization={this.state.localization}
                    as={PhoneInput}
                    tabIndex="1"
                    placeholder={I18n.t("addUsersByPhone_phoneNumber")}
                    autoFormat={false}
                    country={selectCountry(this.props.country)}
                    countryCodeEditable={false}
                    inputProps={{
                      name: "phone",
                      required: true,
                      autoFocus: true,
                      tabIndex: 2,
                    }}
                    value={this.state.users[i].phone}
                    onChange={(e, obj) => this.handlePhoneChange(e, obj, i)}
                    isValid={this.state.users[i].valid}
                    isInvalid={!this.state.users[i].valid}
                    required
                    buttonStyle={{
                      marginTop: "0.40rem",
                      height: "80%",
                      marginLeft: "0.2rem",
                      borderRadius: "21px 0 0 21px",
                      border: "1px",
                    }}
                    inputStyle={{ height: "3.2rem" }}
                  />
                  {i !== 0 && (
                    <button
                      type="button"
                      className="clear"
                      onClick={() => this.handleRemoveInput(i)}
                    >
                      <img src={cross} alt="" />
                    </button>
                  )}
                </span>
                <div className={"invite " + (u.invite ? "show" : "")}>
                  <Translate value="addUsersByPhone_invite1" />
                  <button type="button" className="clear link">
                    <Translate value="addUsersByPhone_clickHere" />
                  </button>
                  <Translate value="addUsersByPhone_invite2" />
                </div>
              </Form.Group>
            ))}
            <Form.Group className="form-field">
              <button
                type="button"
                className="clear"
                onClick={this.handleAddAnotherUser}
                disabled={
                  this.props.isAdmin === false &&
                  this.state.users.length >=
                    this.props.userPackage?.userInChargerGroupsLimit
                }
              >
                <img src={plus} alt="" />
                <Translate value="addUsersByPhone_addAnotherUser" />
              </button>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <button type="submit" form="add-users-form">
            <Translate value="addUsersByPhone_save" />
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  country: state.i18n.locale,
  userPackage: state.account.accountData.userPackage,
  isAdmin: state.account.isAdmin,
});

export default connect(mapStateToProps, { setAlert })(AddUsersByPhone);
